import { createFileRoute } from '@tanstack/react-router';

import { RfqPortal } from '@/areas/customers/CustomerPortalSettings';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/customer-portal/')({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <RfqPortal />;
}
